import React, {useState} from "react";
import "animate.css";
import styles from "../styles/home.module.css";
import AboutComponent from "../components/AboutComponent";

function About() {
  const [focused, setFocused] = useState(true);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <div
      className={`${styles["base-content"]} ${styles["animated-section"]} ${focused ? styles["focused"] : ''}`}
      onFocus={(e)=>handleFocus()}
      onBlur={(e)=>handleBlur()}
    >
      <AboutComponent />
    </div>
  );
}
export default About;
